import { queryOptions, useQuery } from '@tanstack/react-query';
import { getKinexysAccounts, sortKinexysAccounts } from '@/services/api/kinexys';

export const KINEXYS_ACCOUNTS_QUERY_KEY = ['treasury', 'kinexys', 'accounts'] as const;

// Stable module-level select: an inline arrow re-runs every render and churns `data` identity.
const selectAccounts = (data: Awaited<ReturnType<typeof getKinexysAccounts>>) => sortKinexysAccounts(data.accounts);

export const kinexysAccountsQueryOptions = () =>
  queryOptions({
    queryKey: KINEXYS_ACCOUNTS_QUERY_KEY,
    queryFn: getKinexysAccounts,
    select: selectAccounts,
  });

export const useKinexysAccounts = () => useQuery(kinexysAccountsQueryOptions());
